module.exports = "/_next/static/images/AccessibleAiImage@2x-90410c13f6936d121de0dcfbd4ed9d60.webp";